// 主题列表
export const appThemeList = [
  '#5d9dfe',
  '#2d8cf0',
  '#0960bd',
  '#0084f4',
  '#009688',
  '#536dfe',
  '#ff5c93',
  '#ee4f12',
  '#0096c7',
  '#9c27b0',
  '#ff9800',
  '#FF3D68',
  '#00C1D4',
  '#18a058',
  '#78DEC7',
  '#1768AC',
  '#FB9300',
  '#FC5404',
  '#8675ff'
]

// 应用程序主题预设颜色
const setting = {
  //深色主题
  darkMode: 'light',
  //系统主题色
  appTheme: '#5d9dfe',
  //系统内置主题色列表
  appThemeList
}

export default setting
